import { useQuery } from '@tanstack/react-query'
import Activity from '../../model/Activity'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const activitiesQueryKey = (challengeID: string) => ['activities', challengeID] as const

export function useActivities(challengeId?: string) {
  const activeChallengeId = useChallengeId()
  const resolvedChallengeId = challengeId || activeChallengeId

  return useQuery<Activity[]>({
    queryKey: activitiesQueryKey(resolvedChallengeId),
    queryFn: () => dataSource.getActivities(resolvedChallengeId),
    enabled: !!resolvedChallengeId,
  })
}
